import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import LoadingOverlay from "../LoadingOverlay";
import ConfirmDialog from "../ConfirmDialog";

const lbl =
  "block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1";
const inp =
  "w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:ring-1 focus:ring-cyan-400";
const rdOnly =
  "w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm bg-gray-100 text-gray-500 cursor-not-allowed";

function MaterialLocationModal({ dataSet, onClose, refreshData }) {
  const [locationId, setLocationId] = useState("");
  const [locationName, setLocationName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [uploadPending, setUploadPending] = useState(false);

  useEffect(() => {
    if (dataSet) {
      setLocationId(dataSet.product_location_id);
      setLocationName(dataSet.product_location_name);
    }
  }, [dataSet]);

  const updateLocation = async () => {
    setIsLoading(true);
    try {
      const res = await axios.patch(
        "https://eps.elkomprintama.com/patch/api/store/store/material_location",
        {
          product_location_name: locationName.toLocaleUpperCase(),
          product_location_id: locationId,
        },
      );
      if (res.status === 200) {
        toast.success(res.data.msg);
        onClose();
        refreshData();
      }
    } catch (err) {
      toast.error(err?.response?.data?.msg || "Update failed.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!locationName) {
      toast.warning("Please fill in the location name.");
      return;
    }
    setUploadPending(true);
    setShowConfirm(true);
  };

  return (
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md relative overflow-hidden">
      {isLoading && <LoadingOverlay message="Updating…" />}

      {/* Header */}
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
        <div>
          <h2 className="text-sm font-bold text-gray-800">Edit Location</h2>
          <p className="text-xs text-gray-400 mt-0.5">ID: {locationId}</p>
        </div>
        <button
          onClick={onClose}
          className="text-gray-400 hover:text-gray-600 text-2xl font-bold w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition"
        >
          &times;
        </button>
      </div>

      <form onSubmit={handleSubmit} className="px-6 py-5 space-y-4">
        <div>
          <label className={lbl}>Location ID</label>
          <input
            className={rdOnly}
            name="locationid" type="text"
            value={locationId}
            disabled
            readOnly
          />
        </div>

        <div>
          <label className={lbl}>Location Name</label>
          <input
            className={inp}
            name="locationname" type="text"
            placeholder="Location Name"
            value={locationName}
            onChange={(e) => setLocationName(e.target.value)}
          />
        </div>

        <div className="flex gap-2 pt-1">
          <button
            type="submit"
            className="flex-1 py-2.5 rounded-xl text-sm font-bold text-white bg-cyan-700 hover:bg-cyan-800 transition"
          >
            Update
          </button>
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-2.5 rounded-xl text-sm font-bold text-gray-600 bg-gray-100 hover:bg-gray-200 transition"
          >
            Close
          </button>
        </div>
      </form>

      {showConfirm && uploadPending && (
        <ConfirmDialog
          message="Update this location?"
          onConfirm={() => {
            setShowConfirm(false);
            updateLocation();
            setUploadPending(false);
          }}
          onCancel={() => {
            setShowConfirm(false);
            setUploadPending(false);
          }}
        />
      )}
    </div>
  );
}

export default MaterialLocationModal;
